import "./../styles/main.scss";
import $ from "jquery";
import L from "leaflet";
import "leaflet-providers";
import Tabby from "tabbyjs";
import lity from "lity";
require("./helpers/ihavecookie");
// var lity = require("lity");
// function activateTracking() {
// }
$(document).ready(function (e) {
    $(".menuButton").on("click", function (e) {
        e.preventDefault();
        $("#main-header").toggleClass("show-side");
    });
    $("#side").on("click", ".overlay", function () {
        $("#main-header").toggleClass("show-side");
    });
    $('.field-number input').attr("type", "number").attr("min", 0);
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    if ($("#entry_form_accMember").length) {
        var $entryParent = $("#entry_form_accMember");
        var prices_1 = ($("#form").data("prices"));
        var sumTable_1 = $(".field-number.tables").find('.sum').find("span");
        var sumTicket_1 = $(".field-number.tickets").find('.sum').find("span");
        var memberType_1 = null;
        var $fieldNumberTables_1 = $(".field-number.tables").find("input");
        var $fieldNumberTickets_1 = $(".field-number.tickets").find("input");
        var $tablePrices = $(".prices-table"), $tableVatExcl_1 = $tablePrices.find(".vatexl").find("span"), $tableVat_1 = $tablePrices.find(".vat").find("span"), $tableTotal_1 = $tablePrices.find(".total").find("span");
        function computeTotal() {
            if (memberType_1 != null) {
                var tickets = parseInt($fieldNumberTickets_1.val()) * prices_1[memberType_1].ticket;
                var tables = parseInt($fieldNumberTables_1.val()) * prices_1[memberType_1].table;
                var total = tickets + tables;
                var vat = (total * 0.21).toFixed(2);
                var totalVat = total + parseFloat(vat);
                $tableVatExcl_1.html(total.toFixed(2));
                $tableVat_1.html(vat);
                $tableTotal_1.html(totalVat.toFixed(2));
            }
        }
        $entryParent.on("change", "input", function (e) {
            var $elm = $(e.currentTarget);
            var val = $elm.val();
            memberType_1 = val;
            sumTicket_1.html(prices_1[memberType_1].ticket);
            sumTable_1.html(prices_1[memberType_1].table);
            computeTotal();
        });
        var val = $entryParent.find('input:checked').val();
        memberType_1 = val;
        if (memberType_1 != null) {
            sumTicket_1.html(prices_1[memberType_1].ticket);
            sumTable_1.html(prices_1[memberType_1].table);
        }
        $(".field-number").on("change", "input", function (e) {
            computeTotal();
        });
        $(".field-number").find("input").trigger("change");
    }
    $(document).on('click', '[data-lightbox]', lity);
    var options = {
        title: '&#x1F36A; Accept Cookies & Privacy Policy?',
        // title: 'Accept Cookies & Privacy Policy?',
        message: 'This website uses cookies',
        delay: 600,
        expires: 1,
        link: '/legal/cookie-policy',
        onAccept: function () {
            var myPreferences = $.fn.ihavecookies.cookie();
            if (myPreferences.indexOf("analytics") > -1) {
                activateTracking();
            }
        },
        cookieTypes: [
            {
                type: 'Analytics',
                value: 'analytics',
                description: 'Cookies related to site visits, browser types, etc.'
            }
        ],
        uncheckBoxes: true,
        acceptBtnLabel: 'Accept Cookies',
        moreInfoLabel: 'More information',
        cookieTypesTitle: 'Select which cookies you want to accept',
        fixedCookieTypeLabel: 'Essential',
        fixedCookieTypeDesc: 'These are essential for the website to work correctly.'
    };
    $('body').ihavecookies(options);
    if ($.fn.ihavecookies.preference('analytics') === true) {
        activateTracking();
    }
    if ($('#map').length) {
        var coords = [$("#map").data("lat"), $("#map").data("lng")];
        var map = L.map('map', { scrollWheelZoom: false }).setView(coords, 16);
        L.tileLayer.provider("CartoDB.Positron").addTo(map);
        L.marker(coords).addTo(map);
    }
    $('#ihavecookiesBtn').on('click', function (e) {
        e.preventDefault();
        $('body').ihavecookies(options, 'reinit');
    });
    $('.checkbox').on("change", "input", function (e) {
        var elm = $(e.currentTarget);
        if (elm.is(":checked"))
            elm.parent().addClass("checked");
        else
            elm.parent().removeClass("checked");
    });
    if ($('.checkbox input').is(":checked"))
        $('.checkbox input:checked').parent().addClass("checked");
    $('.checkbox').on("click", ".ui", function (e) {
        var elm = $(e.currentTarget);
        var input = elm.parent().find("input");
        input.attr("checked", !input.attr("checked"));
    });
    $(document).on('lity:open', function (event, instance) {
        $("body").on("click", ".next a", function (e) {
            e.preventDefault();
            $('.lity-close').trigger("click");
        });
        $("body").on("click", ".prev a", function (e) {
            e.preventDefault();
            $('.lity-close').trigger("click");
        });
    });
    $("body").on("click", ".speakers .speaker", function (e) {
        // $(e.currentTarget).find(".action a").trigger("click");
    });
    if ($("[data-tabs]").length) {
        var tabs = new Tabby('[data-tabs]');
        $("body").on("click", "#agenda > .navigator > a", function (e) {
            e.preventDefault();
            if ($(e.currentTarget).attr("href") == "#next")
                tabs.toggle($("#agenda").find('*[role="tab"][aria-selected="true"]').parent().next().children('a').get(0));
            else if ($(e.currentTarget).attr("href") == "#previous")
                tabs.toggle($("#agenda").find('*[role="tab"][aria-selected="true"]').parent().prev().children('a').get(0));
        });
    }
});
